import { useTheme } from "@mui/material";
import type { QueryClient } from "@tanstack/react-query";
import {
  createRootRouteWithContext,
  HeadContent,
  Outlet,
} from "@tanstack/react-router";
import { useEffect } from "react";
import type { AuthContextData } from "../@types/contexts/Auth/AuthContext";
import { CookieConsent } from "../components/molecules/CookieConsent";

const Devtools =
  process.env.NODE_ENV === "development"
    ? (await import("./-internal-components/Devtools")).Devtools
    : () => null;

interface MyRouterContext {
  auth: AuthContextData;
  queryClient: QueryClient;
}

const RootComponent: React.FC = () => {
  const theme = useTheme();

  useEffect(() => {
    if (theme.palette.mode === "dark") {
      document.documentElement.classList.add("cc--darkmode");
    } else {
      document.documentElement.classList.remove("cc--darkmode");
    }

    // clear devtools settings to prevent issues with hotkeys
    localStorage.removeItem("tanstack_devtools_settings");
  }, [theme]);

  return (
    <>
      <HeadContent />
      <Outlet />
      <CookieConsent />
      <Devtools />
    </>
  );
};

export const Route = createRootRouteWithContext<MyRouterContext>()({
  component: RootComponent,
});
